var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReataurants(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.008 22.914C2.874 21.018 0 16.842 0 12C0 5.377 5.377 0 12 0C18.623 0 24 5.377 24 12C24 16.439 21.585 20.318 17.998 22.394C18 16.996 18.002 9.585 17.996 8.709C17.993 8.297 17.696 8 17.323 8C16.026 8 14.108 13.17 13.44 19C14.519 18.997 15.496 19 15.496 19V23.482C14.389 23.819 13.216 24 12 24C11.148 24 10.317 23.911 9.516 23.742V17.646C9.516 17.061 9.876 16.881 10.667 16.255C11.261 15.785 11.683 15.043 11.602 14.292C11.371 12.171 10.809 8 10.809 8H10.351V13H9.516L9.35 8H8.881L8.68 13H7.844L7.7 8H7.194L7.008 13H6.172V8H5.672C5.672 8 5.163 12.198 4.954 14.312C4.88 15.053 5.28 15.781 5.861 16.247C6.648 16.877 7.008 17.066 7.008 17.642V22.914Z",
    fill: "#346771"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReataurants);
export default __webpack_public_path__ + "static/media/reataurants.b2415af8230ace2a62846c0222e428c5.svg";
export { ForwardRef as ReactComponent };